var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFreePlan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5585",
    "data-name": "Group 5585",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_497",
    "data-name": "Ellipse 497",
    cx: 56,
    cy: 56,
    r: 56,
    fill: "#f4f4f4",
    stroke: "#e0e0e0",
    strokeWidth: 1,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Baloon",
    transform: "translate(19.491 20.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,0H71.9V71.9H0Z",
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M32.706,44.976A16.028,16.028,0,0,1,37.331,33.7c4.073-4.114,6.057-7.916,6.057-11.389a17.257,17.257,0,1,0-34.513,0c0,3.473,1.985,7.275,6.057,11.389a16.028,16.028,0,0,1,4.625,11.275v.165H32.706ZM6,22.312a20.133,20.133,0,1,1,40.265,0c0,4.342-2.331,8.807-6.89,13.412a13.152,13.152,0,0,0-3.793,9.252v1.6a1.438,1.438,0,0,1-1.438,1.438H18.12a1.438,1.438,0,0,1-1.438-1.438v-1.6a13.152,13.152,0,0,0-3.793-9.252C8.331,31.119,6,26.654,6,22.312Z",
    transform: "translate(11.256 3.752)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M13.876,27.628h5.752V21.876H13.876ZM12.438,19h8.628A1.438,1.438,0,0,1,22.5,20.438v8.628A1.438,1.438,0,0,1,21.066,30.5H12.438A1.438,1.438,0,0,1,11,29.066V20.438A1.438,1.438,0,0,1,12.438,19Z",
    transform: "translate(20.637 35.645)",
    fill: "#fe9920"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreePlan);
export default __webpack_public_path__ + "static/media/free-plan.5a09846e1bb264ee5a44274777bf9d26.svg";
export { ForwardRef as ReactComponent };